<div class="users-dialog">
  <h3>{{text}}</h3>


  <div fxLayout="row" fxLayoutGap="15px" >
    <div  fxFlex="100">
      <app-dict-users  fxFlex="100" label="Użytkownicy" [control]="userControl" [multiple]="false"></app-dict-users>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex></div>
    <div>
      <button [disabled]="!active" (click)="confirm()" mat-raised-button color="primary"><span> Dodaj</span></button>
    </div>
    <div>
      <button (click)="decline()" mat-raised-button color="warn" class="users-dialog-decline-button"><span> Anuluj</span></button>
    </div>
  </div>
</div>
